import { accountIdFormat } from "@redotech/redo-account-id";
import {
  CurrencySchema,
  PriceBookCountriesSchema,
  PriceBookRowSchema,
} from "@redotech/redo-inventory-common/price-book/price-book";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const createPriceBook = unaryRpc({
  name: "createPriceBook" as const,
  input: z.object({
    accountId: accountIdFormat.schema,
    name: z.string(),
    description: z.string().optional(),
    currency: CurrencySchema.nullable().optional(),
    countryCodes: PriceBookCountriesSchema.optional(),
  }),
  output: z.object({ priceBook: PriceBookRowSchema }),
});
